import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState } from 'react';
import { Divider, Flex, Space, Typography } from 'antd';
import { MinusOutlined, PlusOutlined } from '@ant-design/icons';
import { DatePicker } from 'antd';
import dayjs from 'dayjs';
const { RangePicker } = DatePicker;
const DateRangeOptionList = ({ data, name }) => {
    const [collapse, setCollapse] = useState(false);
    const rangePresets = [
        { label: '0 - 10 Days', value: [dayjs(), dayjs().add(10, 'd')] },
        { label: '11 - 30 Days', value: [dayjs().add(11, 'd'), dayjs().add(30, 'd')] },
        { label: '31 - 60 Days', value: [dayjs().add(31, 'd'), dayjs().add(60, 'd')] },
        { label: '61 - 90 Days', value: [dayjs().add(61, 'd'), dayjs().add(90, 'd')] },
        { label: '91 - 180 Days', value: [dayjs().add(91, 'd'), dayjs().add(180, 'd')] },
        { label: 'Over 180 Days', value: [dayjs().add(181, 'd'), dayjs().add(1000, 'd')] },
    ];
    const onRangeChange = (dates, dateStrings, item) => {
        var _a, _b;
        if (dates) {
            (_a = item === null || item === void 0 ? void 0 : item.dateRange) === null || _a === void 0 ? void 0 : _a.setValue(dates, dateStrings);
        }
        else {
            (_b = item === null || item === void 0 ? void 0 : item.dateRange) === null || _b === void 0 ? void 0 : _b.setValue([undefined], [undefined]);
        }
    };
    return (_jsxs(Space, { style: { width: '100%' }, direction: "vertical", children: [_jsxs(Flex, { align: "center", justify: "space-between", children: [_jsx(Typography.Text, { strong: true, children: "Filter By Date Range" }), collapse ? (_jsx(PlusOutlined, { onClick: () => {
                            setCollapse(false);
                        } })) : (_jsx(MinusOutlined, { onClick: () => {
                            setCollapse(true);
                        } }))] }), !collapse &&
                (data === null || data === void 0 ? void 0 : data.map((item) => {
                    var _a, _b, _c, _d;
                    return (_jsxs(Space, { direction: "vertical", style: { width: '100%' }, children: [_jsx(Typography.Text, { children: (_a = item === null || item === void 0 ? void 0 : item.dateRange) === null || _a === void 0 ? void 0 : _a.title }, `${(_b = item === null || item === void 0 ? void 0 : item.dateRange) === null || _b === void 0 ? void 0 : _b.title}_title`), _jsx(RangePicker, { presets: rangePresets, value: (_c = item === null || item === void 0 ? void 0 : item.dateRange) === null || _c === void 0 ? void 0 : _c.value, onChange: (dates, dateStrings) => onRangeChange(dates, dateStrings, item) })] }, `${(_d = item === null || item === void 0 ? void 0 : item.dateRange) === null || _d === void 0 ? void 0 : _d.title}_spc`));
                })), _jsx(Divider, {})] }));
};
export default DateRangeOptionList;
